import { DailyWesternAstrologyContainer } from "./style";
import { HoroscopeDetail, HoroscopeList, HoroscopePredictions } from ".././components";
import { ChineseAstrology } from "../../Astrology/components";
import { useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";

const YearPredictionsZodiac = () => {  

  const dataContext = useContext(TemplateContext);
  const { content: formatContent, ...rest } = dataContext || {};
  const { 
    data: { 
      zodiac, 
      sign, 
      isZodiacChinese, 
      prediction, 
      isTomorrow, 
      isToday, 
      isHowIs, 
      isYearPredictionsZodiac 
    } 
  } = rest?.properties?.service;

  return (
    <DailyWesternAstrologyContainer>
      <HoroscopeDetail sign={sign} isZodiacChinese={isZodiacChinese} isTomorrow={isTomorrow} isToday={isToday} isHowIs={isHowIs} isYearPredictionsZodiac={ isYearPredictionsZodiac }/>
      {isZodiacChinese ?
        <ChineseAstrology zodiac={zodiac}/>
      :
      <>
        <HoroscopePredictions signo={sign?.[0]?.sign} zodiac={zodiac} prediction={prediction} />
        <HoroscopeList signo={sign} zodiac={zodiac} />
      </>
      }
    </DailyWesternAstrologyContainer>
  );
};

export default YearPredictionsZodiac;
